export default {
  title_1: "F.A.Q.".toUpperCase(),
  title_2: "Learn More About VisioN.".toUpperCase(),
  important: "IMPORTANT".toUpperCase(),
  all_answers: "all ANSWERS".toUpperCase(),
  text: "Get all the answers you need about Vision right here. We’re breaking it down for you.".toUpperCase(),
}
